module.exports = __webpack_public_path__ + "img/task_icon3.92bebda9.png";